// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentList_header__1Lt3d","title":"ShipmentList_title__2KmQN","small":"ShipmentList_small__SjqYh","btnContainer":"ShipmentList_btnContainer__10CtZ"};